import {useMutation} from 'react-query';
import actions from '../api/colors';
import {useSetRecoilState} from 'recoil';
import {colors} from '../state/colors';

const useFetchAllColors = () => {
  const setColors = useSetRecoilState(colors);
  return useMutation('useFetchAllColors', async () => {
    const colors = await actions.fetchAllColors();
    setColors(colors.data);
    return colors.data;
  });
};

export default useFetchAllColors;
